import { render, staticRenderFns } from "./cloudBoardUserList.vue?vue&type=template&id=ef87897c&scoped=true"
import script from "./cloudBoardUserList.vue?vue&type=script&lang=js"
export * from "./cloudBoardUserList.vue?vue&type=script&lang=js"
import style0 from "./cloudBoardUserList.vue?vue&type=style&index=0&id=ef87897c&prod&lang=scss&scoped=true"
import style1 from "./cloudBoardUserList.vue?vue&type=style&index=1&id=ef87897c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef87897c",
  null
  
)

export default component.exports